import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { serverInfo } from "../../../../../App";
import EventImg from "../../../../../assets/images/SakibBanner2.png";
const JurySingleCardSchedule = ({ title, image }) => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);
  const location = useLocation();
  const eventType = location.state;
  const [postData, setPostData] = useState([]);

  useEffect(() => {
    axios
      .get(`/api/jury-board/dashboard/posts/${eventType?.title}`)
      .then((res) => {
        if (res.data.status === 200) {
          console.log(res.data);
          setPostData(res.data.audition);
        }
      });
  }, []);

  return (
    <>
      <div className="row">
        {postData?.map((post) => (
          <div className="containerSa col-md-3 mb-3">
            <div className="ClassHeadApp">
              <div className="container-lg">
                <div className="ClassHeadC">
                  <h5 className="Approved-C fw-bold">
                    {moment(post?.created_at).format("LL")}{" "}
                  </h5>
                  <small className="text-light fw-bold">
                    <i className="fa-solid fa-clock"></i>{" "}
                    {moment(post?.created_at).format("HH:mm a")}
                  </small>
                  <p className="text-warning fw-bold">
                    Participate : {post?.participant?.length}
                  </p>
                </div>
              </div>
            </div>
            <div className="overlayASchedule bg-info ApprovedS">
              <Link
                to={`/jury-board/schedule/single/${post?.id}/${eventType?.title}`}
              >
                <div className="text-center">
                  <button className="fw-bold text-light pb-3 mt-3">
                    <i className="fa-solid fa-eye"></i>
                  </button>
                </div>
              </Link>

              <div className="containerADS">
                <img
                  src={
                    post?.banner
                      ? post?.banner == null
                        ? EventImg
                        : imageCdnUrl+post?.banner
                      : post.video == null
                      ? EventImg
                      : videoCdnUrl+post?.video
                  }
                  alt="Snow"
                  className="Img-Sch-Event "
                />

                {/* Background color */}
                <div className="LeftTopScA"> </div>
                {/* Background color */}

                <div className="LeftTopSc">
                  <h5 className="mt-2 text-warning title-limit">{title}</h5>
                  <Markup
                    className="text-white des-limit"
                    content={post?.description}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default JurySingleCardSchedule;
